import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router';
import { subscriptionErrorParamName } from './Login.constants';
import getLoginErrorMessage from './getLoginErrorMessage';
import { StyledErrorMessage } from './Login.styles';

function wrapErrorMessage(message: ReactNode | undefined) {
  return (
    <StyledErrorMessage data-testid="error-message">
      {message}
    </StyledErrorMessage>
  );
}

const LoginFormErrorMessageRenderer = ({
  noticeMessage,
}: {
  noticeMessage: ReactNode | undefined;
}) => {
  const [searchParams] = useSearchParams();

  if (noticeMessage) {
    return wrapErrorMessage(noticeMessage);
  }

  const subscriptionError = searchParams.get(subscriptionErrorParamName);

  if (subscriptionError) {
    const subscriptionDueDays = searchParams.get('sdd');
    const subscriptionManagementLink = searchParams.get('sml') || '';

    const message = getLoginErrorMessage({
      errorCode: subscriptionError,
      subscriptionManagementLink,
      subscriptionPaymentDueDays: subscriptionDueDays
        ? parseInt(subscriptionDueDays, 10)
        : undefined,
    });

    return wrapErrorMessage(message);
  }

  return null;
};

export default LoginFormErrorMessageRenderer;
